module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('banner'), _vm._v(" "), _c('div', {
    staticClass: "active_tab"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/active"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("热门活动")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/history"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("历史活动")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "active_cont"
  }, [_c('router-view')], 1), _vm._v(" "), _c('to-top')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ffdd65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 62
// module chunks = 0